export enum ECartActionTypes {
    HYDRATE_CART = '@cart/HYDRATE_CART',
    ADD_ITEM = '@cart/ADD_ITEM',
    SET_QUANTITY = '@cart/SET_QUANTITY',
    INCREMENT_QUANTITY = '@cart/INCREMENT_QUANTITY',
    DECREMENT_QUANTITY = '@cart/DECREMENT_QUANTITY',
    RESTORE_ITEM = '@cart/RESTORE_ITEM',
    DELETE_ITEM = '@cart/DELETE_ITEM',
    DELETE_SELECTED_ITEMS = '@cart/DELETE_SELECTED_ITEMS',
    SELECT_ITEM = '@cart/SELECT_ITEM',
    SELECT_ALL_AVAILABLE_ITEMS = '@cart/SELECT_ALL_AVAILABLE_ITEMS',
    CLEAR_CART = '@cart/CLEAR_CART',
    SET_ITEM_AVAILABILITY = '@cart/SET_ITEM_AVAILABILITY',
}
